import React, { useCallback } from 'react';
import { IDatabaseListProps } from '../DatabaseList/DatabaseList';
import { makeStyles } from 'tss-react/mui';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import DatabaseAutocompleteSelect from '../DatabaseAutocompleteSelect/DatabaseAutocompleteSelect';
import { useBaseRouteParams } from '../../Features/Routing/Utils/routerUtils';

interface IProps extends IDatabaseListProps {
  disabled?: boolean;
}

const useStyles = makeStyles()(theme => ({
  avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: theme.typography.pxToRem(14),
    background: theme.customProperties.AvatarList.activeBackground,
    color: theme.customProperties.AvatarList.activeTextColor,
    border: theme.customProperties.AvatarList.activeBorder,
  },
  icon: {
    color: theme.palette.common.white,
  },
  typography: {
    display: 'inline',
    whiteSpace: 'nowrap',
  },
  label: {
    paddingRight: theme.spacing(0.5),
  },
}));

/**
 * Komponent för att visa vilka enheter användaren har tillgång till. Växlar mellan DatabaseList och DatabaseAvatarList för visning beroende på skärmstorleken.
 */
const DatabaseSelect: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes, cx } = useStyles();
  const [{ database }, setBaseRoute] = useBaseRouteParams();
  const selectDatabase = useCallback(
    (database: string) =>
      setBaseRoute(oldValues => ({ ...oldValues, database: database })),
    [setBaseRoute]
  );

  if (props.databases.length === 0) {
    return (
      <EDTypography
        className={cx(classes.typography, classes.label)}
        color="inherit"
      >
        Databas saknas
      </EDTypography>
    );
  }
  if (props.databases.length === 1 && props.databases[0].name === database) {
    return (
      <EDTypography
        variant="subtitle2"
        className={cx(classes.typography, classes.label)}
        color="inherit"
        data-testid="DatabaseSelect"
      >
        {database}
      </EDTypography>
    );
  }

  return (
    <DatabaseAutocompleteSelect
      selectedDatabase={database}
      databases={props.databases}
      onDatabaseChange={selectDatabase}
      fixedWidth={props.fixedWidth}
    />
  );
};

export default DatabaseSelect;
